var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"label":_vm.label,"prepend-icon":_vm.icon,"clearable":true,"multiple":"","chips":"","deletable-chips":"","dense":"","item-text":"name","item-value":"id"},on:{"change":_vm.signalChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }